<div [attr.text]="text" [ngClass]="badgeContainerClasses">
    <span [ngClass]="badgeStyleClasses"></span>
</div>

